// File: OnlineCharteredAccountantServices.jsx
import React from "react";

export default function OnlineCharteredAccountantServices() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Online Chartered Accountant Services
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides virtual CA services for businesses.
          </p>
          <p className="text-gray-700">
            Complete online CA support including cloud accounting, virtual audits, remote tax filing, real-time compliance dashboard, GST reconciliation, MCA filings, and 24/7 document portal access through secure digital platform.
          </p>
        </div>

        {/* Right: Image (CA Professional working) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1200&q=80"
              alt="Professional chartered accountant providing online CA services"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures secure online document upload for virtual CA services.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial records and bank statements</li>
                <li>Tax records (ITR, GST returns, TDS)</li>
                <li>Invoices, receipts, payment proofs</li>
                <li>Statutory compliance documents</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Qualified professionals providing reliable virtual CA support nationwide.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Qualified CA Professionals
                </h3>
                <p className="text-gray-700 text-sm">
                  ICAI registered Chartered Accountants with 10+ years experience offering virtual bookkeeping, GST compliance, ITR/TDS filing, statutory audit coordination, MCA/ROC compliances, payroll processing, and virtual CFO services through secure cloud platform.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable 24/7 Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Real-time compliance dashboard, instant document upload portal, video consultation scheduling, mobile app access, automated compliance reminders, multi-channel support (chat/email/call), and guaranteed response within 2 hours ensuring uninterrupted virtual CA assistance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Virtual Services
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end online solutions including Tally/QuickBooks cloud implementation, bank reconciliation automation, GST 3B/GSTR-1 filing, ITR-1 to ITR-7 e-filing, Form 16/16A generation, advance tax planning, refund tracking, and virtual board meeting support with bank-level security.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
